export const apiUrl = '/api';
export const isMobile = (() => {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];
    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
})();
export const activities = {
    'proxying': 'Работаю',
    'refreshing': 'Переподключаюсь',
    'switching_ip': 'Меняю IP',
    'updating': 'Обновляюсь'
};
export const batteryHealths = {
    1: 'неизвестно',
    2: 'всё хорошо',
    3: 'перегрев',
    4: 'всё плохо',
    5: 'перенапряжение',
    6: 'ошибка',
    7: 'холодно'
};
